import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["data-track"]
const _hoisted_2 = { class: "w-full lg:w-auto" }
const _hoisted_3 = { class: "mx-auto mb-12 mt-4 w-[432px] max-w-full px-4 text-sm lg:mt-10" }
const _hoisted_4 = { class: "tw mx-auto mb-10 max-w-screen-px1408 lg:grid lg:grid-cols-[432px_1fr]" }
const _hoisted_5 = { class: "mx-auto mb-15 mt-5 w-[432px] max-w-full px-4 text-sm lg:col-[1_/_2] lg:row-[1_/_2] lg:mx-[unset] lg:mb-0 lg:mt-8 lg:w-full" }

import { onBeforeUnmount, onMounted, ref, watch, Ref } from "vue";
import OcmMessenger from "ocm_mercurius_messenger";
import CloseButton from "@SharedVueComponents/CloseButton/CloseButton.vue";
import HeadlineModalMobil from "@/components/HeadlineModalMobil.vue";
import HeadlineModalDesktop from "@/components/HeadlineModalDesktop.vue";
import HeadlineLandingpageDesktop from "@/components/HeadlineLandingPage.vue";
import LandingpagePicture from "@/components/ImageLandingPage.vue";
import IntroductionText from "@/components/IntroductionText.vue";
import SocialLogin from "@/components/SocialLogin.vue";
import LoginForm from "@/components/LoginForm.vue";
import { messengerPublicationTypes } from "@ocm/services/services.constants.js";
import { pushEvent } from "@/services/dataLayerLogin";
import { store } from "@/state/store";
import BottomContentModal from "@/components/BottomContentModal.vue";
import ImageModalDesktop from "@/components/ImageModalDesktop.vue";
import BenefitsLandingpage from "@/components/BenefitsLandingPage.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const benefits: Ref<{ benefitItems: []; benefitsBackgroundImageURL: string | undefined }> = ref({
	benefitItems: [],
	benefitsBackgroundImageURL: undefined,
});
let isFirstRequest = true;

watch(
	() => store.isLogin,
	() => {
		scrollContentToTop();
	}
);

const loginAreaSubscriberId = ref<number | null>(null);

onMounted(() => {
	showLoginOrRegister();
	fetchBenefits()
		.then(async (response) => await response.json())
		.then((data: { benefitItems?: []; benefitsBackgroundImages?: [] }) => {
			benefits.value.benefitItems = data.benefitItems || [];
			benefits.value.benefitsBackgroundImageURL = buildBenefitsBackgroundImageURL(data.benefitsBackgroundImages || []);
		});
	loginAreaSubscriberId.value = OcmMessenger.subscribe(messengerPublicationTypes.REQUEST_LOGIN, onRequestLogin, {
		REACT_TO_LATEST: true,
	});
});

const loginForm = ref<InstanceType<typeof LoginForm> | null>(null);
const socialLoginComponent = ref<typeof SocialLogin | null>(null);
const loginWrapper = ref<HTMLDivElement | null>(null);

onBeforeUnmount(() => {
	OcmMessenger.unsubscribe(loginAreaSubscriberId.value);
});

function closeLayer() {
	OcmMessenger.publish(messengerPublicationTypes.ABORTED_LOGIN);
	// send Tracking for Closing Layer
	const trackingAction = store.isLogin ? "LoginLayerClosed" : "RegistrationLayerClosed";
	pushEvent(trackingAction);
}

function scrollContentToTop() {
	if (loginWrapper.value) {
		loginWrapper.value.scrollTop = 0;
	}
}

function showLoginOrRegister() {
	// Prio 1: Seite mit In-Page-Registration-Button immer Registrieren
	// Prio 2: Url-Parameter urlParamLogin
	// Prio 3: Url-Parameter urlParamRegistration
	// Prio 4: localStorage (entweder gar nicht vorhanden oder "true" ist niemals "false"
	// Prio 5: modal immer LoginLandingpages, sonst (signinPage und inPageForm) immer Registrieren,

	const hasInPageRegistrationButton = !!document.querySelector("[data-registration=true]");
	const urlParamLogin = getParam("login") !== null;
	const urlParamRegistration = getParam("registration") !== null;
	const storageLoginActive = localStorage.getItem("loginTabActive") === "true";

	if (hasInPageRegistrationButton) {
		store.isLogin = false;
	} else if (urlParamLogin) {
		store.isLogin = true;
	} else if (urlParamRegistration) {
		store.isLogin = false;
	} else if (storageLoginActive) {
		store.isLogin = true;
	} else {
		store.isLogin = !store.isLandingPage;
	}
}

function getParam(paramName: string) {
	return new URLSearchParams(window.location.search).get(paramName);
}

function onRequestLogin() {
	if (isFirstRequest) {
		loginForm.value?.requestFirstLogin();
		isFirstRequest = false;
		return;
	}

	scrollContentToTop();
	loginForm.value?.clearFormData();
	store.globalErrorMessages = [];
	store.httpErrorStatusCode = null;
}

function fetchBenefits() {
	// fetchLabel mit URL nur an die Stelle von der es geholt wird (so dass rest.js allgemeiner ist)
	return fetch(`${window.ocm.config.encodedContextPath}/rest/login-layer/content`);
}

function buildBenefitsBackgroundImageURL(responsiveImages: []) {
	// select largest ImageURL from responsive Images
	const responsiveImagesObj: { SMALL?: string; MEDIUM?: string; LARGE?: string } = {};
	responsiveImages.forEach(
		(image: { url: string; resolutionType: "SMALL" | "MEDIUM" | "LARGE" }) =>
			(responsiveImagesObj[image.resolutionType] = image.url)
	);
	const imageURL = responsiveImagesObj["LARGE"] || responsiveImagesObj["MEDIUM"] || responsiveImagesObj["SMALL"];

	if (!imageURL) return;
	// check and add resourcesHostname
	const baseImageURL = window.ocm.config.imagesHostname;

	return !baseImageURL ? imageURL : new URL(imageURL, baseImageURL).href;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(store).isLandingPage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "tw relative h-screen w-full max-w-[1440px] overflow-hidden bg-white pt-18 lg:p-0",
          "data-track": _unref(store).isLogin ? 'LoginLayer' : 'RegistrationLayer'
        }, [
          _createVNode(CloseButton, {
            class: "absolute right-4 top-4 lg:right-6.5 lg:top-6.5",
            onClick: closeLayer
          }),
          _createVNode(HeadlineModalMobil),
          _createElementVNode("div", {
            ref_key: "loginWrapper",
            ref: loginWrapper,
            class: "size-full overflow-auto lg:grid lg:grid-cols-2"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(HeadlineModalDesktop),
                _createVNode(IntroductionText),
                _createVNode(LoginForm, {
                  ref_key: "loginForm",
                  ref: loginForm
                }, null, 512),
                _createVNode(SocialLogin, {
                  ref_key: "socialLoginComponent",
                  ref: socialLoginComponent,
                  class: "mb-12"
                }, null, 512),
                _createVNode(BottomContentModal, {
                  items: benefits.value.benefitItems
                }, null, 8, ["items"])
              ])
            ]),
            _createVNode(ImageModalDesktop, {
              "img-source": benefits.value.benefitsBackgroundImageURL
            }, null, 8, ["img-source"])
          ], 512)
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    (_unref(store).isLandingPage)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 1,
          to: "#LandingPageMediaComponentWrapper"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(LandingpagePicture, { class: "lg:col-[2_/_3] lg:row-[1_/_2]" }),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(HeadlineLandingpageDesktop),
              _createVNode(IntroductionText),
              _createVNode(LoginForm, {
                ref_key: "loginForm",
                ref: loginForm
              }, null, 512),
              _createVNode(SocialLogin, {
                ref_key: "socialLoginComponent",
                ref: socialLoginComponent
              }, null, 512)
            ]),
            _createVNode(BenefitsLandingpage, {
              items: benefits.value.benefitItems,
              class: "lg:col-[1_/_3] lg:row-[2_/_3]"
            }, null, 8, ["items"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})